module.exports = __webpack_public_path__ + "static/media/medal.668a22e5.svg";